import React, { FC, useState } from 'react';
import { ReactComponent as Intensity_setupIcon } from '../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg';
import { ReactComponent as EditIcon } from '../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg';
import { EquipmentIcon } from 'src/utils/equipmentIcons';

export const getIntensityActiveDots = (intensity: string | number | undefined): number => {
  if (typeof intensity === 'number') {
    if (intensity >= 1 && intensity <= 3) return intensity * 2;
    if (intensity >= 1 && intensity <= 6) return intensity;
    return 4;
  }
  if (!intensity) return 4;
  const normalized = String(intensity).toLowerCase().trim().replace(/[-_]/g, '');
  if (normalized.includes('low')) return 2;
  if (normalized.includes('high')) return 6;
  if (
    normalized.includes('balance') ||
    normalized.includes('medium') ||
    normalized.includes('moderate')
  )
    return 4;
  return 4;
};

import { EquipmentsModal } from './EquipmentsModal';

interface IntensityCardProps {
  programData: any;
  getSlugTitle: (slug: string) => string;
  onEdit?: () => void;
}

export const IntensityCard: FC<IntensityCardProps> = ({ programData, getSlugTitle, onEdit }) => {
  const [isEquipmentsModalOpen, setIsEquipmentsModalOpen] = useState(false);
  const equipments = programData?.equipments || [];
  const visibleEquipments = equipments.slice(0, 3);
  const remainingCount = equipments.length - 3;

  const isManuallyGenerated =
    programData?.isManually === true ||
    programData?.isAIGenerate === false ||
    !programData?.progress?.training_goal;

  return (
    <>
      <div className="program-card">
        <div className="card-header">
          <div className="icon">
            <Intensity_setupIcon />
          </div>
          <h3>Intensity & Setup</h3>
          {!isManuallyGenerated && (
            <button className="edit-btn" onClick={onEdit}>
              <EditIcon style={{ cursor: 'pointer' }} />
            </button>
          )}
        </div>
        <div className="card-body">
          <div className="info-row align-center space-between">
            <span className="label">
              Intensity: <span className="value">{getSlugTitle(programData.intensity)}</span>
            </span>
            <div className="value-dots">
              {Array.from({ length: 6 }).map((_, idx) => (
                <div
                  key={idx}
                  className={`dot ${idx < getIntensityActiveDots(programData?.intensity) ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>
          {visibleEquipments.map((eq: string, i: number) => (
            <div key={i} className="info-row align-center space-between">
              <span className="value">{getSlugTitle(eq)}</span>
              <span className="icon-img">
                <EquipmentIcon slug={eq} />
              </span>
            </div>
          ))}
          {equipments.length > 3 && (
            <div className="show-more-toggle" onClick={() => setIsEquipmentsModalOpen(true)}>
              Show +{remainingCount}
            </div>
          )}
        </div>
      </div>

      <EquipmentsModal
        isOpen={isEquipmentsModalOpen}
        onClose={() => setIsEquipmentsModalOpen(false)}
        equipments={equipments}
        getSlugTitle={getSlugTitle}
      />
    </>
  );
};
